import { Injectable, EventEmitter } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Subject, BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { Location } from '@angular/common';
const googleCalendarRootUrl = 'https://content.googleapis.com';

@Injectable()
export class PlatfromCalendarService {
    onEventUpdated = new Subject<any>();
    OnEventAdded = new Subject<any>();
    OnEventDeleted = new Subject<any>();
    OnReloadRequired = new Subject<any>();
    CalendarViewChanged = new Subject<any>();
    fromEmModule = new BehaviorSubject(false);
    header: any = new HttpHeaders({
        'Content-Type': 'application/json'
    });

    constructor(private http: HttpClient, private location: Location) {}
    getCalendarViews(): any {
        return {
            day: 'day',
            week: 'week',
            month: 'month'
        };
    }

    OnEventUpdate(event) {
        this.onEventUpdated.next(event);
    }
    OnNewEventCreated(event) {
        this.OnEventAdded.next(event);
    }
    OnDeleteEvent(event) {
        this.OnEventDeleted.next(event);
    }
    ReloadRequired(payload) {
        this.OnReloadRequired.next(payload);
    }
    OnCalendarViewChanged() {
        this.CalendarViewChanged.next(true);
    }

    getGoogleCalendarEvents(userData): any {
        return this.http
            .get(
                googleCalendarRootUrl +
                    '/calendar/v3/calendars/primary/events?key=AIzaSyDOU-wW-RCptyZDHOTka1daebsCQ4k7Ywg',
                {
                    headers: this.getGoogleCalendarHeader(userData),
                    withCredentials: true,
                    observe: 'response'
                }
            )
            .pipe(
                map((response: any) => {
                    return response && response.body;
                })
            );
    }
    createCalendar(userData): any {
        return this.http
            .post(
                googleCalendarRootUrl +
                    '/calendar/v3/calendars?alt=json&key=AIzaSyDOU-wW-RCptyZDHOTka1daebsCQ4k7Ywg',
                { summary: 'myCal22222' },
                {
                    headers: this.getGoogleCalendarHeader(userData),
                    withCredentials: true,
                    observe: 'response'
                }
            )
            .pipe(
                map((response: any) => {
                    return response && response.body;
                })
            );
    }

    insertGoogleCalendarEvents(userData, payload) {
        return this.http
            .post(
                googleCalendarRootUrl +
                    '/calendar/v3/calendars/primary/events?key=AIzaSyDOU-wW-RCptyZDHOTka1daebsCQ4k7Ywg',
                payload,
                {
                    headers: this.getGoogleCalendarHeader(userData),
                    withCredentials: true,
                    observe: 'response'
                }
            )
            .pipe(
                map((response: any) => {
                    return response && response.body;
                })
            );
    }

    getGoogleCalendarHeader(userData) {
        return new HttpHeaders({
            'Content-Type': 'application/json',
            Referer: 'https://explorer.apis.google.com',
            Authorization: 'Bearer ' + userData.token
        });
    }

    getAuthorizationInCronofy(clientId, scope, redirectUrl?) {
        window.location.href = `https://app.cronofy.com/oauth/authorize?response_type=code&client_id=${clientId}&redirect_uri=${redirectUrl}&scope=${scope}`;
    }
    getAuthorizationInKloudless(clientId, scope, redirectUrl?) {
        window.location.href = `https://api.kloudless.com/v1/oauth/?response_type=code&client_id=${clientId}&redirect_uri=${redirectUrl}&scope=${scope}&state=CSRF_PREVENTION_TOKEN`;
    }
    setQueryParams(view) {
        let queryParams = `view=${view}`;
        this.location.go(location.pathname, queryParams);
    }
}
